import { graphql, useStaticQuery } from 'gatsby';
import { useMergePrismicPreviewData } from 'gatsby-plugin-prismic-previews';
import React, { useEffect, useRef, useState } from 'react';
import Menu from 'react-burger-menu/lib/menus/slide';
import Box from '../Box/Box';
import ContentContainer from '../ContentContainer/ContentContainer';
import { Body1, Body2, Caption, Headline } from '../Typography/Typography';
import PrismicLink from '../PrismicLink/PrismicLink';
import CollapseContainer from '../CollapseContainer/CollapseContainer';
import { theme } from '../../../config/theme';
import { rem } from 'polished';
import { css } from 'styled-components';
import Image from '../Image/Image';
import { TiEyeOutline, TiHeartOutline } from 'react-icons/ti';
import { IoIosClose } from 'react-icons/io';
import Grid from '../Grid/Grid';

const SideMenu = ({
    isOpen,
    ctaGroup,
    logoLink,
    logo,
    onClose,
    navigations,
}) => {
    const [close, setClose] = useState(false);

    useEffect(() => {
        if (close) onClose();

        return () => setClose(false);
    }, [onClose, close]);

    return (
        <Menu
            isOpen={isOpen}
            customBurgerIcon={false}
            customCrossIcon={false}
            disableAutoFocus
            noOverlay
            width="100%"
            css={`
                background: ${({ theme }) => theme.colors.primary[1800]};
                top: 0;
                height: 100vh !important;
            `}
            right
        >
            <Grid height="100%">
                <Box
                    display="flex"
                    flexDirection="column"
                    height="100%"
                    paddingBottom={rem(16)}
                    gridColumn="1/-1"
                >
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        minHeight="var(--header-height)"
                    >
                        <PrismicLink target="_self" link={logoLink}>
                            <Box height={['21px', null, null, '31px']} fluid>
                                <Image img={logo} height="100%" />
                            </Box>
                        </PrismicLink>
                        <Box
                            as="button"
                            onClick={() => setClose(true)}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <IoIosClose
                                size={rem(40)}
                                color={theme.colors.white}
                            />
                        </Box>
                    </Box>
                    <Box
                        as="ul"
                        overflow="auto"
                        flex="1"
                        paddingBottom={rem(30)}
                    >
                        {navigations.map(
                            ({ navigation_options, category }, i) => {
                                const isMegaMenu =
                                    navigation_options.document.__typename ==
                                    'PrismicNavigationOptions';
                                const megaMenuData =
                                    navigation_options.document.data?.body;
                                // const slug = navigation_options.slug;

                                if (isMegaMenu)
                                    return (
                                        <CollapseContainer
                                            initiallyOpen={false}
                                            key={i}
                                        >
                                            <CollapseContainer.Header>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    borderTop="1px solid white"
                                                    alignItems="center"
                                                    height={rem(56)}
                                                    paddingX={rem(8)}
                                                >
                                                    <Headline
                                                        as="li"
                                                        color={
                                                            theme.colors.white
                                                        }
                                                    >
                                                        {category}
                                                    </Headline>
                                                    <CollapseContainer.Arrow
                                                        size={32}
                                                        color={
                                                            theme.colors.white
                                                        }
                                                    />
                                                </Box>
                                            </CollapseContainer.Header>
                                            <CollapseContainer.Item>
                                                <Box
                                                    css={css`
                                                        + * {
                                                            margin-top: ${rem(
                                                                16
                                                            )};
                                                        }
                                                        > :last-of-type {
                                                            margin-bottom: ${rem(
                                                                24
                                                            )};
                                                        }
                                                    `}
                                                >
                                                    {megaMenuData?.map(
                                                        (
                                                            { primary, items },
                                                            j
                                                        ) => (
                                                            <Box
                                                                padding={rem(8)}
                                                            >
                                                                <Body1
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .white
                                                                    }
                                                                    bold
                                                                    padding={rem(
                                                                        8
                                                                    )}
                                                                    marginBottom={rem(
                                                                        8
                                                                    )}
                                                                >
                                                                    {
                                                                        primary.subcategory
                                                                    }
                                                                </Body1>
                                                                {items.map(
                                                                    (
                                                                        {
                                                                            option,
                                                                            description,
                                                                            link,
                                                                        },
                                                                        j
                                                                    ) => (
                                                                        <PrismicLink
                                                                            link={
                                                                                link
                                                                            }
                                                                            key={
                                                                                j
                                                                            }
                                                                            onClick={() => {
                                                                                setClose(
                                                                                    true
                                                                                );
                                                                            }}
                                                                            css={css`
                                                                                &
                                                                                    a {
                                                                                    padding: ${rem(
                                                                                        8
                                                                                    )};
                                                                                    min-height: ${rem(
                                                                                        56
                                                                                    )};
                                                                                    color: ${({
                                                                                        theme,
                                                                                    }) =>
                                                                                        theme
                                                                                            .colors
                                                                                            .white};
                                                                                    display: grid;
                                                                                    row-gap: ${rem(
                                                                                        4
                                                                                    )};
                                                                                }
                                                                                &
                                                                                    + *
                                                                                    a {
                                                                                    margin-top: ${rem(
                                                                                        8
                                                                                    )};
                                                                                }
                                                                            `}
                                                                        >
                                                                            <Body2
                                                                                color={
                                                                                    theme
                                                                                        .colors
                                                                                        .white
                                                                                }
                                                                            >
                                                                                {
                                                                                    option
                                                                                }
                                                                            </Body2>
                                                                            <Caption
                                                                                color={
                                                                                    theme
                                                                                        .colors
                                                                                        .white
                                                                                }
                                                                            >
                                                                                {
                                                                                    description
                                                                                }
                                                                            </Caption>
                                                                        </PrismicLink>
                                                                    )
                                                                )}
                                                            </Box>
                                                        )
                                                    )}
                                                </Box>
                                            </CollapseContainer.Item>
                                        </CollapseContainer>
                                    );
                                return (
                                    <Box
                                        display="flex"
                                        borderTop="1px solid white"
                                    >
                                        <Headline as="li" key={i}>
                                            <PrismicLink
                                                link={navigation_options}
                                                css={css`
                                                    & a {
                                                        color: ${({ theme }) =>
                                                            theme.colors.white};
                                                        height: ${rem(56)};
                                                        display: flex;
                                                        align-items: center;
                                                        padding-inline: ${rem(
                                                            8
                                                        )};
                                                    }
                                                `}
                                            >
                                                {category}
                                            </PrismicLink>
                                        </Headline>
                                    </Box>
                                );
                            }
                        )}
                    </Box>
                    <Box padding={rem(8)} display="grid" gridRowGap={rem(16)}>
                        {ctaGroup}
                    </Box>
                </Box>
            </Grid>
        </Menu>
    );
};

export default SideMenu;
